import ApiService from "@/services/api.service"

export const AIPhotoStudyService = {
  uploadToDiagnocat(patientId, studyId) {
    return ApiService.post(`patient/${patientId}/study/${studyId}/upload`)
  },
  getDiagnocatLink(patientId, studyId, type = 'webpage') {
    return ApiService.get(`patient/${patientId}/study/${studyId}/link?type=${type}`)
  },
  startStudyMultiupload(studyId, fileKeys) {
    return ApiService.post(`patient/study/${studyId}/multiupload/start`, { fileKeys })
  },
  finishStudyMultiupload(studyId, sessionId) {
    return ApiService.post(`patient/study/${studyId}/multiupload/finish`, { sessionId })
  }
}
